import React from 'react'
import { Alert, Button, Link, Stack, Typography } from '@mui/material'
import { TypedFormik } from '@dai/components'
import { User } from 'firebase/auth'

export interface SendVerificationEmailProps {
  navigateToUpdateEmail: () => void
  sendEmailVerification: () => Promise<void>
  user: User | null
}

const SendVerificationEmail: React.FC<SendVerificationEmailProps> = ({
  navigateToUpdateEmail,
  sendEmailVerification,
  user,
}) => {
  const ERROR_MESSAGES: Record<string, string> = {
    'auth/too-many-requests':
      'Too many requests. Check that your email is correct or try again later.',
    'auth/user-not-found': 'User not found.',
    'auth/unauthorized-domain':
      'This domain is not authorized for OAuth operations.',
  }

  return (
    <TypedFormik
      initialValues={{}}
      onSubmit={async (_, { setStatus }) => {
        try {
          if (!user?.email) throw new Error('User not found')
          await sendEmailVerification()
          setStatus({
            success: true,
            message: `Verification email sent to ${user.email}.`,
          })
        } catch (error: any) {
          const message =
            ERROR_MESSAGES[error.code] ||
            error.message ||
            'Something went wrong'
          setStatus({ success: false, message })
        }
      }}
    >
      {({ status, handleSubmit, isSubmitting }) => {
        return (
          <form noValidate onSubmit={handleSubmit}>
            <Stack spacing={4}>
              {status?.message && (
                <Alert severity={status.success ? 'info' : 'warning'}>
                  {status.message}
                </Alert>
              )}
              <Button
                type="submit"
                fullWidth
                color="primary"
                variant="contained"
                loading={isSubmitting}
                loadingPosition="end"
              >
                Resend Email
              </Button>
              <Typography variant="body2" color="text.secondary" align="center">
                Need to update your email address?{' '}
                <Link
                  sx={{ cursor: 'pointer' }}
                  variant="body2"
                  onClick={navigateToUpdateEmail}
                >
                  Update email
                </Link>
              </Typography>
            </Stack>
          </form>
        )
      }}
    </TypedFormik>
  )
}

export default SendVerificationEmail
